import { useEffect, useState } from "react";
import { useApi } from "../../../../services/HttpService";
import { DataListInfoTable } from "../../../../components/tables/DataTable";
import ScrollableDataGrid from "../../../../components/tables/ScrollableDataGrid";
import { Box, Paper, Typography } from "@mui/material";
import { EnhancedTableToolbar } from "../../../../components/tables/AdminTable";
import BaseModal from "../../../../components/modals/BaseModal";
import { EditAgreement } from "./EditAgreement";
import { GridColDef } from "@mui/x-data-grid";

const mainColumns: GridColDef[] = [
  { field: "id", headerName: "ID", width: 70 },
  { field: "name", headerName: "Navn", width: 160 },
  { field: "company_id", headerName: "Company", width: 160 },
  { field: "contact_id", headerName: "Contact", width: 160 },
  { field: "from_date", headerName: "From", width: 160 },
  { field: "to_date", headerName: "To", width: 160 },
  { field: "updated_at", headerName: "Updated at", width: 160 },
];

export const LicenseAgreementList = () => {
  const { api, isLoading, error } = useApi();

  const [list, setList] = useState([]);

  const [showAdd, setShowAdd] = useState(false);

  const fetchList = async () => {
    const res = await api("/la-agreement/list", "GET", { primaries: true });
    console.log(res);
    if (res && res.statusCode === 200) {
      setList(res.list);
    } else {
      return [];
    }
  };

  const [editId, setEditId] = useState(-1);

  useEffect(() => {
    fetchList();
  }, []);

  return (
    <div>
      <Typography typography={"h3"} sx={{ mt: 2 }}>
        Agreements
      </Typography>
      <Paper elevation={3} sx={{ borderRadius: "4px 4px 0 0" }}>
        <EnhancedTableToolbar
          title={"Agreements"}
          // numSelected={openEditUser || selectedIds.length > 0 ? 1 : 0}
          // selectTitle={user.id ? `${user.first_name} ${user.last_name} (${user.username})` : "Ny bruker"}
          onAdd={() => setShowAdd(true)}
          // onEdit={() => setOpenEditUser(true)}
          // onCancel={() => { setOpenEditUser(false); setSelectedIds([]); setUser(newUser()) }}
          // onDelete={() => setOpenDelete(true)}
          // onSearch={handleSearch}
          // onRefresh={getUsers}
        />
      </Paper>
      <BaseModal
        open={showAdd}
        title={"Agreement"}
        onClose={() => setShowAdd(false)}
        closeOnBackdropClick={false}
        showButtons={false}
      >
        <EditAgreement
          id={0}
          onSuccess={() => {
            fetchList();
            setShowAdd(false);
          }}
        />
      </BaseModal>
      {editId > 0 && (
        <BaseModal
          open={true}
          title={"Agreement"}
          onClose={() => {
            setEditId(-1);
          }}
          closeOnBackdropClick={false}
          showButtons={false}
        >
          <EditAgreement
            id={editId}
            onSuccess={() => {
              fetchList();
              setEditId(-1);
            }}
          />
        </BaseModal>
      )}
      <Box sx={{ mt: 2 }}>
        <ScrollableDataGrid
          columns={mainColumns}
          rows={list}
          onPageRequest={() => {}}
          loading={false}
          onRowDoubleClick={(params) => {
            setEditId(params.id as number);
          }}
        />
      </Box>
    </div>
  );
};
